<template>
  <div v-if="showContent">
    <div class="tabs-container">
      <button
        :data-testid="`${title}-tab`"
        v-for="{ title, component } in components"
        :key="title"
        @click="changeTab(component)"
        :class="{ active: currentComponent === component && components.length > 1 }"
      >
        {{ title }}
      </button>
    </div>
    <keep-alive include="MoreDestinations">
      <component :is="currentComponent" v-bind="currentProperties" />
    </keep-alive>
  </div>
</template>

<script>
import AllDestinations from './AllDestionations.vue'
import HotDestinations from './HotDestinations.vue'
import MoreDestinations from './MoreDestinations.vue'
import { createNamespacedHelpers } from 'vuex'
import availableCitiesMixin from '../mixins/availableCities'
import { expiredOffer, isFlagActive } from '@/infrastructure/Configuration'

const { mapGetters } = createNamespacedHelpers('offersDestinations')

export default {
  name: 'Tabs',
  components: {
    AllDestinations,
    HotDestinations,
    MoreDestinations
  },
  mixins: [availableCitiesMixin],
  data() {
    return {
      components: [],
      currentComponent: '',
      expiredOffer: expiredOffer,
      dataReady: false
    }
  },
  computed: {
    ...mapGetters(['selectedCode', 'offer', 'hotDestinations', 'allDestinations']),
    isFfQubitFixesEnabled() {
      return global.ConfigDynamic?.isEnabled({ key: 'default.qubit.fixes.active' })
    },
    isSmartLinkingEnabled() {
      return isFlagActive('smart.linking.client.enabled')
    },
    showContent() {
      return this.isFfQubitFixesEnabled ? this.dataReady : true
    },
    currentProperties() {
      const props = {
        HotDestinations: {},
        AllDestinations: {},
        MoreDestinations: {}
      }

      return props[this.currentComponent]
    },
    emptyHotDestinations() {
      return this.isFfQubitFixesEnabled
        ? !this.availableCities.length
        : this.offer.cities.length === 0
    },
    hasExternalHotelCodes() {
      return (
        Array.isArray(this.offer?.externalHotelCodes) && this.offer.externalHotelCodes.length > 0
      )
    },
    shouldShowMoreDestinations() {
      return (
        this.isSmartLinkingEnabled && this.offer?.type === 'multi' && this.hasExternalHotelCodes
      )
    }
  },
  created() {
    this.dataReady = false
    this.onDisplayTabs()
  },
  methods: {
    changeTab(tab) {
      this.currentComponent = tab
    },
    onDisplayTabs() {
      if (this.expiredOffer) {
        this.components = [
          { title: this.translate('offAllDestinations'), component: AllDestinations }
        ]
        this.currentComponent = AllDestinations
      } else if (this.emptyHotDestinations) {
        this.components = [
          { title: this.translate('offAllDestinations'), component: AllDestinations }
        ]

        if (this.shouldShowMoreDestinations) {
          this.components.push({
            title: this.translate('weMoreDestinationsAt'),
            component: MoreDestinations
          })
        }

        this.currentComponent = AllDestinations
      } else {
        this.components = [
          { title: this.translate('offHotDestinations'), component: HotDestinations },
          { title: this.translate('offAllDestinations'), component: AllDestinations }
        ]

        if (this.shouldShowMoreDestinations) {
          this.components.push({
            title: this.translate('weMoreDestinationsAt'),
            component: MoreDestinations
          })
        }

        this.currentComponent = HotDestinations
      }
    }
  },
  watch: {
    hotDestinations: {
      handler(newVal) {
        if ((newVal && newVal.length > 0) || this.allDestinations.length > 0) {
          this.dataReady = true
          this.onDisplayTabs()
        }
      },
      immediate: true
    },
    selectedCode() {
      this.currentComponent = AllDestinations
    }
  }
}
</script>

<style scoped lang="scss">
.tabs-container {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 2.5rem;

  button,
  .allDestinationStyle {
    border-top: 0 solid transparent;
    border-left: 0 solid transparent;
    border-right: 0 solid transparent;
    border-bottom: 1px solid var(--color-grey-light);
    font-weight: 400;
    padding: 10px;
    background: white;
    color: var(--color-grey-dark);

    &:hover {
      border-bottom: 1px solid var(--color-red);
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }
  }

  button.active {
    border-bottom: 1px solid var(--color-red);
    color: black;
  }

  .allDestinationStyle {
    pointer-events: none;
  }
}
</style>
